/**
 * NavaBackdrop — fundo decorativo (cena azul profunda + grade).
 *
 * Visual Sphere: brilho radial azul no alto à direita, gradiente do fundo para o
 * fundo profundo e grade de 64 px só no topo, atenuada por máscara (nunca sob
 * tabelas). Camadas decorativas: `aria-hidden` e `pointer-events: none`.
 * `position: absolute; inset: 0` — o pai deve ter `position: relative`.
 */
import { C } from '@/theme/palette';

export function NavaBackdrop() {
  return (
    <>
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          backgroundImage:
            `radial-gradient(ellipse at 68% 0%, ${C.blackElev2}E6 0%, transparent 46%), ` +
            `radial-gradient(ellipse at 0% 100%, ${C.blackElev}99 0%, transparent 40%), ` +
            `linear-gradient(140deg, ${C.black}, ${C.bgDeep} 72%)`,
        }}
      />
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: '0 0 auto 0',
          height: 420,
          pointerEvents: 'none',
          backgroundImage:
            `linear-gradient(${C.cyberDim}1A 1px, transparent 1px), ` +
            `linear-gradient(90deg, ${C.cyberDim}1A 1px, transparent 1px)`,
          backgroundSize: '64px 64px',
          maskImage: 'linear-gradient(#000a, #0000)',
          WebkitMaskImage: 'linear-gradient(#000a, #0000)',
        }}
      />
    </>
  );
}
